import { render, staticRenderFns } from "./table-item.vue?vue&type=template&id=42edb0f6&lang=pug&"
import script from "./table-item.vue?vue&type=script&lang=js&"
export * from "./table-item.vue?vue&type=script&lang=js&"
import style0 from "./table-item.vue?vue&type=style&index=0&id=42edb0f6&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports